import React, { useMemo, useState, useEffect, useRef } from 'react'
import { Button, Modal } from 'antd'
import Uploadfiles from '../../modules/uploadfiles'
import request from '../../tools/request'
import { RcFile } from 'antd/lib/upload'
import { uploadType } from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { download } from '@/tools'

export interface DownloadConfig {
  url: string
  method?: 'GET' | 'POST'
  params?: any | (() => any | Promise<any>)
}

export interface UploadAreaProps {
  title?: string
  dataSource: fileFile[]
  onChange: (list: fileFile[]) => void
  getOriginFile?: (f: RcFile) => void
  accept?: string
  maxCount?: number
  directlyDelete?: boolean
  type?: uploadType
}

export interface ImportTemplateModalProps {
  buttonText?: string
  modalTitle?: string
  width?: number | string
  style?: React.CSSProperties
  open?: boolean
  onOpenChange?: (open: boolean) => void
  confirmLoading?: boolean
  onConfirm: () => void
  onCancel?: () => void
  downloadConfig: DownloadConfig
  uploadProps: UploadAreaProps
}

function ImportTemplateModal(props: ImportTemplateModalProps) {
  const {
    buttonText = '导入',
    modalTitle = '导入模板',
    width = '30%',
    style = { top: '25%' },
    open,
    onOpenChange,
    confirmLoading,
    onConfirm,
    onCancel,
    downloadConfig,
    uploadProps,
  } = props
  const defaultUploadProps = {
    title: '选择文件',
    accept: '.xlsx,.xls',
    maxCount: 1,
    directlyDelete: true,
  }
  const mergedUploadProps = useMemo(
    () => ({ ...defaultUploadProps, ...uploadProps }),
    [uploadProps],
  )

  const [innerOpen, setInnerOpen] = useState(false)
  const visible = useMemo(
    () => (open !== undefined ? open : innerOpen),
    [open, innerOpen],
  )

  const prevVisibleRef = useRef<boolean>(visible)
  useEffect(() => {
    if (prevVisibleRef.current && !visible) {
      mergedUploadProps.onChange([])
    }
    prevVisibleRef.current = visible
  }, [visible, mergedUploadProps])

  const handleOpen = () => {
    if (onOpenChange) {
      onOpenChange(true)
    } else {
      setInnerOpen(true)
    }
  }

  const handleCancel = () => {
    mergedUploadProps.onChange([])
    onCancel && onCancel()
    if (onOpenChange) {
      onOpenChange(false)
    } else {
      setInnerOpen(false)
    }
  }

  const handleDownloadTemplate = async () => {
    const { url, method = 'POST', params } = downloadConfig
    const realParams = typeof params === 'function' ? await params() : params
    download(url, realParams)
  }

  return (
    <>
      <Button onClick={handleOpen}>{buttonText}</Button>
      <Modal
        title={modalTitle}
        open={visible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={width}
        style={style}
        okText="提交"
        cancelButtonProps={{
          disabled: !!confirmLoading,
          onClick: handleCancel,
        }}
        okButtonProps={{
          type: 'primary',
          loading: !!confirmLoading,
          onClick: onConfirm,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={handleDownloadTemplate}>下载导入模板</a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title={mergedUploadProps.title || '选择文件'}
            dataSource={mergedUploadProps.dataSource}
            onChange={mergedUploadProps.onChange}
            getOriginFile={mergedUploadProps.getOriginFile}
            accept={mergedUploadProps.accept}
            maxCount={mergedUploadProps.maxCount ?? 1}
            directlyDelete={mergedUploadProps.directlyDelete}
            type={mergedUploadProps.type}
          />
          {!mergedUploadProps.dataSource.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </>
  )
}

export default ImportTemplateModal
import React, { useMemo, useState, useEffect, useRef } from 'react'
import { Button, Modal } from 'antd'
import Uploadfiles from '../../modules/uploadfiles'
import request from '../../tools/request'
import { RcFile } from 'antd/lib/upload'
import { uploadType } from '../../api/orderManage'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { download } from '@/tools'

export interface DownloadConfig {
  url: string
  method?: 'GET' | 'POST'
  params?: any | (() => any | Promise<any>)
}

export interface UploadAreaProps {
  title?: string
  dataSource: fileFile[]
  onChange: (list: fileFile[]) => void
  getOriginFile?: (f: RcFile) => void
  accept?: string
  maxCount?: number
  directlyDelete?: boolean
  type?: uploadType
}

export interface ImportTemplateModalProps {
  buttonText?: string
  modalTitle?: string
  width?: number | string
  style?: React.CSSProperties
  open?: boolean
  onOpenChange?: (open: boolean) => void
  confirmLoading?: boolean
  onConfirm: () => void
  onCancel?: () => void
  downloadConfig: DownloadConfig
  uploadProps: UploadAreaProps
}

function ImportTemplateModal(props: ImportTemplateModalProps) {
  const {
    buttonText = '导入',
    modalTitle = '导入模板',
    width = '30%',
    style = { top: '25%' },
    open,
    onOpenChange,
    confirmLoading,
    onConfirm,
    onCancel,
    downloadConfig,
    uploadProps,
  } = props
  const defaultUploadProps = {
    title: '选择文件',
    accept: '.xlsx,.xls',
    maxCount: 1,
    directlyDelete: true,
  }
  const mergedUploadProps = useMemo(
    () => ({ ...defaultUploadProps, ...uploadProps }),
    [uploadProps],
  )

  const [innerOpen, setInnerOpen] = useState(false)
  const visible = useMemo(
    () => (open !== undefined ? open : innerOpen),
    [open, innerOpen],
  )

  const prevVisibleRef = useRef<boolean>(visible)
  useEffect(() => {
    if (prevVisibleRef.current && !visible) {
      mergedUploadProps.onChange([])
    }
    prevVisibleRef.current = visible
  }, [visible, mergedUploadProps])

  const handleOpen = () => {
    if (onOpenChange) {
      onOpenChange(true)
    } else {
      setInnerOpen(true)
    }
  }

  const handleCancel = () => {
    mergedUploadProps.onChange([])
    onCancel && onCancel()
    if (onOpenChange) {
      onOpenChange(false)
    } else {
      setInnerOpen(false)
    }
  }

  const handleDownloadTemplate = async () => {
    const { url, method = 'POST', params } = downloadConfig
    const realParams = typeof params === 'function' ? await params() : params
    download(url, realParams)
  }

  return (
    <>
      <Button onClick={handleOpen}>{buttonText}</Button>
      <Modal
        title={modalTitle}
        open={visible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width={width}
        style={style}
        okText="提交"
        cancelButtonProps={{
          disabled: !!confirmLoading,
          onClick: handleCancel,
        }}
        okButtonProps={{
          type: 'primary',
          loading: !!confirmLoading,
          onClick: onConfirm,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={handleDownloadTemplate}>下载导入模板</a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title={mergedUploadProps.title || '选择文件'}
            dataSource={mergedUploadProps.dataSource}
            onChange={mergedUploadProps.onChange}
            getOriginFile={mergedUploadProps.getOriginFile}
            accept={mergedUploadProps.accept}
            maxCount={mergedUploadProps.maxCount ?? 1}
            directlyDelete={mergedUploadProps.directlyDelete}
            type={mergedUploadProps.type}
          />
          {!mergedUploadProps.dataSource.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </>
  )
}

export default ImportTemplateModal
